import { createSelector } from 'reselect';
import basketSelector from 'selectors/basket/basketSelector';

const hasPickupBasketSelector = createSelector(basketSelector, basket => (basket?.pickupBasket?.itemCount ?? 0) > 0);

export { hasPickupBasketSelector };
